import React from "react";

const Loading = (props) => {
  // console.log("Props in Loadig", props);
  return (
    <div className={`overlay`}>
      <div className={`loading`}></div>
    </div>
  );
};

export default Loading;
